import React from "react";
import MarketingPage from "./MarketingPage";
import { useParams } from "react-router-dom";

const industries = {
  mining: { title: "Mining", body: "Operational procedures, maintenance instructions, inspection documentation and safety-related documentation." },
  engineering: { title: "Engineering", body: "Technical procedures, project documentation, reports and work instructions." },
  construction: { title: "Construction", body: "Site procedures, inspection forms, quality documentation and operational records." },
  manufacturing: { title: "Manufacturing", body: "SOPs, work instructions, maintenance instructions and production documentation." },
  "professional-services": { title: "Professional Services", body: "Policies, proposals, reports, procedures and repeatable client deliverables." },
};

export default function Solutions() {
  const { industry } = useParams();
  const one = industry ? industries[industry] : null;
  return (
    <MarketingPage eyebrow="Solutions" title={one ? one.title : "Documentation that fits how your industry works."} subtitle={one ? one.body : "Fexidoc adapts to the documentation your team already produces — from operational procedures to technical reports."}>
      {!one && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Object.entries(industries).map(([slug, d]) => (
            <a href={`/solutions/${slug}`} key={slug} className="fx-panel p-6 fx-hover-panel block">
              <div className="mono text-[10px] uppercase tracking-widest text-cyan-300">{slug}</div>
              <div className="font-display text-lg font-semibold text-slate-100 mt-1">{d.title}</div>
              <div className="text-slate-400 text-sm mt-2 leading-relaxed">{d.body}</div>
            </a>
          ))}
        </div>
      )}
    </MarketingPage>
  );
}
